import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Input } from "../../components/ui/input";
import { ymd, fmtGiornoLong } from "./helpers";

export default function DaySelector({ data, setData, extra }) {
  const shift = (n) => { const d = new Date(data + "T00:00:00"); d.setDate(d.getDate() + n); setData(ymd(d)); };
  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <div className="flex items-center gap-1.5 bg-white border rounded-xl px-2 py-1.5">
        <button onClick={() => shift(-1)} className="text-slate-400 hover:text-sky-600 p-1" title="Giorno precedente" data-testid="pul-day-prev"><ChevronLeft size={18} /></button>
        <div className="text-center min-w-[190px]">
          <div className="font-bold text-sm" data-testid="pul-day-label">{fmtGiornoLong(data)}</div>
          <Input type="date" value={data} onChange={(e) => setData(e.target.value)} className="h-7 text-xs border-0 shadow-none px-0 text-center text-muted-foreground focus-visible:ring-0" data-testid="pul-date" />
        </div>
        <button onClick={() => shift(1)} className="text-slate-400 hover:text-sky-600 p-1" title="Giorno successivo" data-testid="pul-day-next"><ChevronRight size={18} /></button>
      </div>
      {extra}
    </div>
  );
}
